import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import ErrorContainer, { parseAxiosError } from 'src/Layouts/ErrorContainer';

import AnythingDetailsDate from './date';
import AnythingDetailsImageUrl from './image_url';
import AnythingDetailsImageS3 from './image_s3';
import AnythingDetailsPosition from './position';
import AnythingDetailsText from './text';
import AnythingDetailsLink from './url';
import { useAnything } from 'src/queries/anything';

const Type = styled.div`
  color: ${({ theme }) => theme.colors.N60};
  font-weight: bold;
`;

function AnythingDetails({ id, ...rest }) {
  const { isLoading, error, data: anything } = useAnything(id);

  if (isLoading) {
    return null;
  }

  if (error) {
    return <ErrorContainer {...parseAxiosError(error)} />;
  }

  let typeComponent;
  switch (anything.type) {
    case 'DATE':
      typeComponent = <AnythingDetailsDate anything={anything} />;
      break;
    case 'IMAGE_URL':
      typeComponent = <AnythingDetailsImageUrl anything={anything} />;
      break;
    case 'IMAGE_S3':
      typeComponent = <AnythingDetailsImageS3 anything={anything} />;
      break;
    case 'POSITION':
      typeComponent = <AnythingDetailsPosition anything={anything} />;
      break;
    case 'TEXT':
      typeComponent = <AnythingDetailsText anything={anything} />;
      break;
    case 'URL':
      typeComponent = <AnythingDetailsLink anything={anything} />;
      break;
    default:
      typeComponent = (
        <div {...rest}>
          <h3>{anything.title}</h3>
          <Type>{anything.type}</Type>
          <div>
            {anything.value1}
            <br />
            {anything.value2}
          </div>
        </div>
      );
  }

  return (
    <>
      {typeComponent}

      <div className="mt-3">
        <i>
          Belongs to{' '}
          <Link to={`/somethings/${anything.SomethingId}`}>Something</Link>
        </i>
      </div>
    </>
  );
}

export default AnythingDetails;
